var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20.4 20.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-sound-x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    className: "st0",
    d: "M10.2 20.401C4.569 20.394.007 15.831 0 10.2.007 4.57 4.57.007 10.2 0c5.63.007 10.193 4.57 10.2 10.2-.007 5.631-4.569 10.194-10.2 10.201zm0-19.444A9.252 9.252 0 00.957 10.2c.006 5.103 4.141 9.239 9.243 9.244 5.103-.006 9.239-4.141 9.244-9.244A9.253 9.253 0 0010.2.957z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    className: "st0",
    d: "M10.532 14.206V6.101a.57.57 0 00-.309-.515.562.562 0 00-.618.103L6.311 8.366h-1.75a.665.665 0 00-.618.618v2.367a.666.666 0 00.618.618h1.75l3.229 2.726a.578.578 0 00.41.168.582.582 0 00.583-.57c.005.001-.001-.087-.001-.087z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.095 13.664l-.047.002a.652.652 0 01-.462-.191l-.087-.088a.653.653 0 01-.063-.851c.489-.66.748-1.442.748-2.262 0-.883-.293-1.71-.848-2.394a.653.653 0 01.045-.874l.087-.087a.635.635 0 01.495-.19.651.651 0 01.473.239 5.168 5.168 0 011.176 3.307c0 1.137-.36 2.22-1.04 3.13a.653.653 0 01-.477.259z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.797 15.684a.653.653 0 01-.472.231l-.027.001a.652.652 0 01-.462-.191l-.086-.086a.654.654 0 01-.038-.883 6.975 6.975 0 001.635-4.483 6.956 6.956 0 00-1.75-4.616.653.653 0 01.026-.894l.086-.086a.657.657 0 01.952.027 8.38 8.38 0 012.115 5.57 8.403 8.403 0 01-1.979 5.41z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon01);
export default __webpack_public_path__ + "static/media/sound-icon-01.8adc646c.svg";
export { ForwardRef as ReactComponent };